import React from "react";
import Users from "./Users";

const Admin = () => {
  return (
    <div style={{ paddingTop: "0%", display: "flex", flexDirection: "column" }}>
      <Users />
    </div>
  );
};

export default Admin;
